// extracted by mini-css-extract-plugin
export var wrapper = "BreadcrumbBar-module--wrapper--SBStm";
export var content = "BreadcrumbBar-module--content--lkP-g";
export var separator = "BreadcrumbBar-module--separator--ReaOM";
export var current = "BreadcrumbBar-module--current--ccHcu";